module.exports = __webpack_public_path__ + "img/melia-room-2.e13e33e5.jpg";